import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FarmerService } from 'src/app/services/farmer.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import { RoleType } from 'src/enum/roletype';
import * as moment from 'moment';
import swal from 'sweetalert2';
import { FileType } from 'src/enum/fileType.enum';
import { AttachmentType } from 'src/enum/attachmentType.enum';
import { DisableService } from 'src/app/services/disable.service';
import { CashBookingService } from 'src/app/services/cashbooking.service';
import { MachineryAndImplementStatus } from 'src/enum/machinaryandimplementsstatustype';
@Component({
  selector: 'app-remarks-popup',
  templateUrl: './remarks-popup.component.html',
  styleUrls: ['./remarks-popup.component.scss']
})
export class RemarksPopupComponent implements OnInit {
  item: any;
  form: FormGroup;
  currentDate: any;
  roleId: number;
  public roleEnum = RoleType;
  fileName2: any;
  BannerImage2: File
  dateWithTime2: string;
  bannerImageSrc2: string | null = null;
  userImageBase642: string | null = null;
  attachmentData: any[] = [];
  FileExtention2: any;
  imgs: any = ['png', 'jpeg', 'jpg', 'PNG', 'JPEG', 'JPG'];
  fileTypeEnum = FileType
  attachmentType = AttachmentType;
  url: string | null = null;
  rolename: any;
  fileName: string;
  dateWithTime: string;
  FileExtention: string;
  BannerImage: any;
  userImageBase64: string;
  url1: string;
  machineryStatusTypeList: any[] = [];
  MachineryAndImplementStatus = MachineryAndImplementStatus;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dataRecievedToAdd: any,
    public dialogRef: MatDialogRef<RemarksPopupComponent>,
    private formBuilder: FormBuilder,
    private farmerService: FarmerService,
    private usersession: UserSessionService,
    public disableService: DisableService,
    private cashbookingService: CashBookingService,

  ) {
    this.item = this.dataRecievedToAdd.item;
    this.roleId = this.usersession.roleId();
    this.rolename = this.usersession.roleName();
  

  }

  ngOnInit(): void {
    this.initialValidators();
    this.getMachineryStatusType();
  }

  initialValidators() {
    this.form = this.formBuilder.group({
      remarks: ['', Validators.required],
      imageName2: [null, Validators.required],
      imageName1: [null],
      aeVerifiedBy: ['', Validators.required],
      aeVerifiedByMobileNo: ['', Validators.required],
      machineryAndImplementStatus: [null, Validators.required],
    })
    // this.form.get('machineryAndImplementStatus')?.valueChanges.subscribe((value) => {
    //   const imageName2Control = this.form.get('imageName2');
    //   if (value !== 4) {
    //     imageName2Control?.setValidators(Validators.required);
    //   } else {
    //     imageName2Control?.clearValidators();
    //   }
    //   imageName2Control?.updateValueAndValidity();
    // });
    if (this.roleId == this.roleEnum.AssistantExecutiveEngineer) {
      this.form.controls['imageName2'].clearValidators();
      this.form.controls['imageName2'].updateValueAndValidity();

      this.form.controls['aeVerifiedBy'].clearValidators();
      this.form.controls['aeVerifiedBy'].updateValueAndValidity();

      this.form.controls['aeVerifiedByMobileNo'].clearValidators();
      this.form.controls['aeVerifiedByMobileNo'].updateValueAndValidity();
    }

  }

  getMachineryStatusType() {
    this.cashbookingService.getmachineryAndImplementStatusTypeLookup(true)
      .subscribe((res: any) => {
        this.machineryStatusTypeList = res;
      });
  }

  selectFile2(): void {
    if (!this.fileName2) {
      this.form.controls['imageName2'].markAsTouched()

      const inputElement = document.createElement('input');
      inputElement.type = 'file';
      inputElement.style.display = 'none';
      document.body.appendChild(inputElement);
      inputElement.click();
      inputElement.addEventListener('change', (event) => {
        const files: FileList | null = (event.target as HTMLInputElement).files;

        if (!files || files.length == 0) {
          swal.fire('Warning', 'Please upload file', 'warning');
          return;
        }
        this.dateWithTime2 = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
        this.fileName2 = files?.item(0)?.name;
        var file: any = files.item(0);
        var fileExtension = this.fileName2.slice(this.fileName2.lastIndexOf('.') + 1);
        var type = '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
        var result = '|png|jpeg|jpg|pdf|doc'.indexOf(type) !== -1 || '|png|jpeg|jpg|pdf|doc'.indexOf(fileExtension) !== -1;

        if (this.form.value.imageName2) {
          let i = this.attachmentData.findIndex(v => v.attachmentFilename === this.form.value.imageName2);
          if (i !== -1) this.attachmentData.splice(i, 1);
        }

        if (!result) {
          swal.fire('Warning', `Please upload a Correct File Format (PNG, JPEG, JPG)`, 'warning');
          this.fileName2 = '';
          this.dateWithTime2 = '';
          this.form.controls['imageName2'].setValue('');
          return;
        }
        if (file.size > 2097152) {
          swal.fire('Warning', `The file being uploaded can't be more than 2MB`, 'warning');
          this.fileName2 = '';
          this.dateWithTime2 = '';
          this.form.controls['imageName2'].setValue('');
          return;
        }
        this.FileExtention2 = fileExtension;
        this.BannerImage2 = file;
        const reader1 = new FileReader();
        reader1.onloadend = () => {
          this.userImageBase642 = reader1.result as string;
          this.userImageBase642 = `data:image/${fileExtension === 'jpg' || type === 'jpeg' ? 'jpeg' : 'png'};base64,${this.userImageBase642.split(',')[1]}`;
          this.url = this.userImageBase642.split(',')[1]

          let bannerImageElement = document.getElementById('bannerImage2') as HTMLImageElement;
          bannerImageElement.src = this.userImageBase642;
          let fileType
          if (type == '|pdf|') {
            fileType = this.fileTypeEnum.Pdf
          }
          else {
            fileType = this.fileTypeEnum.Image
          }
          this.attachmentData.push({
            id: 0,
            base64String: this.url,
            attachmentFilename: this.fileName2,
            fileType: fileType,
            attachmentType: this.attachmentType.AeVerificationImage,
          });
        };
        reader1.readAsDataURL(file);
        reader1.onerror = function () {
          swal.fire('Error', 'Failed to read file', 'error');
        };
        document.body.removeChild(inputElement);
        this.form.controls['imageName2'].setValue(this.fileName2);
      });
    }
  }
  deleteImage(controller: any, id: any) {
    const txt = 'இதை நிச்சயமாக நீக்க வேண்டுமா?';
    const Yes = 'ஆம்';
    const No = 'இல்லை';
    swal.fire({
      text: txt,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: Yes,
      cancelButtonText: No,

    }).then((result) => {
      if (result.value) {
        if (controller == 'imageName2') {
          this.fileName2 = "";
          this.dateWithTime2 = " ";
          this.form.controls[controller].setValue('');
          let index = this.attachmentData.find(x => x.attachmentType == this.attachmentType.AeVerificationImage)
          this.attachmentData.splice(index, 1)
        }
        else if (controller == 'imageName1') {
          this.fileName = "";
          this.dateWithTime = " ";
          this.form.controls[controller].setValue('');
          let index = this.attachmentData.find(x => x.attachmentType == this.attachmentType.AeVerificationImage1)
          this.attachmentData.splice(index, 1)
        }


      }
    });
  }

  selectFile(): void {
    if (!this.fileName) {
      this.form.controls['imageName1'].markAsTouched()

      const inputElement = document.createElement('input');
      inputElement.type = 'file';
      inputElement.style.display = 'none';
      document.body.appendChild(inputElement);
      inputElement.click();
      inputElement.addEventListener('change', (event) => {
        const files: FileList | null = (event.target as HTMLInputElement).files;

        if (!files || files.length == 0) {
          swal.fire('Warning', 'Please upload file', 'warning');
          return;
        }
        this.dateWithTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
        this.fileName = files?.item(0)?.name;
        var file: any = files.item(0);
        var fileExtension = this.fileName.slice(this.fileName.lastIndexOf('.') + 1);
        var type = '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
        var result = '|png|jpeg|jpg|pdf|doc'.indexOf(type) !== -1 || '|png|jpeg|jpg|pdf|doc'.indexOf(fileExtension) !== -1;

        if (this.form.value.imageName1) {
          let i = this.attachmentData.findIndex(v => v.attachmentFilename === this.form.value.imageName1);
          if (i !== -1) this.attachmentData.splice(i, 1);
        }

        if (!result) {
          swal.fire('Warning', `Please upload a Correct File Format (PNG, JPEG, JPG)`, 'warning');
          this.fileName = '';
          this.dateWithTime = '';
          this.form.controls['imageName1'].setValue('');
          return;
        }
        if (file.size > 2097152) {
          swal.fire('Warning', `The file being uploaded can't be more than 2MB`, 'warning');
          this.fileName = '';
          this.dateWithTime = '';
          this.form.controls['imageName1'].setValue('');
          return;
        }
        this.FileExtention = fileExtension;
        this.BannerImage = file;
        const reader1 = new FileReader();
        reader1.onloadend = () => {
          this.userImageBase64 = reader1.result as string;
          this.userImageBase64 = `data:image/${fileExtension === 'jpg' || type === 'jpeg' ? 'jpeg' : 'png'};base64,${this.userImageBase64.split(',')[1]}`;
          this.url1 = this.userImageBase64.split(',')[1]

          let bannerImageElement = document.getElementById('bannerImage') as HTMLImageElement;
          bannerImageElement.src = this.userImageBase64;
          let fileType
          if (type == '|pdf|') {
            fileType = this.fileTypeEnum.Pdf
          }
          else {
            fileType = this.fileTypeEnum.Image
          }
          this.attachmentData.push({
            id: 0,
            base64String: this.url1,
            attachmentFilename: this.fileName,
            fileType: fileType,
            attachmentType: this.attachmentType.AeVerificationImage1,
          });
        };
        reader1.readAsDataURL(file);
        reader1.onerror = function () {
          swal.fire('Error', 'Failed to read file', 'error');
        };
        document.body.removeChild(inputElement);
        this.form.controls['imageName1'].setValue(this.fileName);
      });
    }
  }


  onCancel() {
    this.dialogRef.close(false);
  }

  onSave() {
    if(this.form.get('machineryAndImplementStatus')?.value == this.MachineryAndImplementStatus.MachineryImplementNotshownduringVerification){
      this.form.controls['imageName2'].clearValidators();
      this.form.controls['imageName2'].updateValueAndValidity();
    }
    if(this.item.serviceProviderType==1){
      this.form.controls['machineryAndImplementStatus'].clearValidators();
      this.form.controls['machineryAndImplementStatus'].updateValueAndValidity();
    }
    if (this.form.valid) {
      this.disableService.show();
      var data = {
        vehicleId: this.item.id,
        remarks: this.form.value.remarks,
        attachment: this.attachmentData?this.attachmentData:'',
        aeVerifiedBy: this.form.value.aeVerifiedBy,
        aeVerifiedByMobileNo: this.form.value.aeVerifiedByMobileNo,
        machineryAndImplementStatusType: this.form.value.machineryAndImplementStatus?this.form.value.machineryAndImplementStatus:0,
      }
      let api;
      this.roleId === this.roleEnum.AssistantEngineer ? api = this.farmerService.verify(data) : api = this.farmerService.approveOrReject(data);
      api.subscribe(res => {
        if (res && res.isSuccess) {
          this.dialogRef.close(true);
        }
      })
    } else {
      this.form.markAllAsTouched();
    }
  }

}
